import React from "react";
import { Button, Container } from "react-bootstrap";
import { NavLink } from "react-router-dom";

const Header = () => {
  return (
    <>
      <div className="p-3 bg-light">
        <Container>
          <div className="hstack justify-content-between">
            <h5 className="m-0">Password Manager [PM]</h5>
            <NavLink to={"/login"}>
              <Button>Get Started!</Button>
            </NavLink>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Header;
